import constants from '../constants';

const isElementDetached = (element) =>
  !!(
    element &&
    (element.hasAttribute(constants.attributes.DETACHED_GLOBAL) ||
      element.hasAttribute(constants.attributes.DETACHED_CHILDREN_GLOBAL))
  );

export default isElementDetached;
